<template>
  <div class="body_container">
    <div class="width_margin">
      <div class="container_content_list_title">맞춤진단개발</div>
    </div>

    <div class="width_margin">
      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication43.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#현업 중심</div>
            </div>
          </div>
        </div>
        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">맞춤 진단 개발 및 컨설팅</div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title"></div>
          <div class="container_content_text_content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Diagnosisdev",
};
</script>

<style></style>
